<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-2">
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0">{{ $t('stockIn.invoiceNumber') }}</label>
          <input
            v-model="model.invoice_no"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('invoice_no') }"
          />
          <div class="invalid-feedback" v-if="errors.has('invoice_no')">
            {{ errors.first('invoice_no') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="required ts-mb-0">{{ $t('stockIn.vendor') }}</label>
          <a-select
            v-model="model.vendor_id"
            :options="vendorList"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('vendor_id') }"
          ></a-select>
          <div class="invalid-feedback" v-if="errors.has('vendor_id')">
            {{ errors.first('vendor_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-6">
          <label class="required ts-mb-0">{{ $t('stockIn.product') }}</label>
          <a-select
            v-model="model.product_id"
            :options="productList"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onProductChange"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('product_id') }"
          ></a-select>
          <div class="invalid-feedback" v-if="errors.has('product_id')">
            {{ errors.first('product_id') }}
          </div>
        </div> -->
        <div class="col-md-12">
          <label class="required ts-mb-0">{{ $t('stockIn.location') }}</label>
          <a-select
            class="ts-w-full"
            v-model="model.location_id"
            :options="locationList"
            :disabled="true"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :class="{ 'is-invalid': errors.has('location_id') }"
          ></a-select>
          <div class="invalid-feedback" v-if="errors.has('location_id')">
            {{ errors.first('location_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('stockIn.product') }}</label>
          <div class="ts-border ts-p-2 ts-rounded-md ts-relative">
            <button
              @click.prevent="addRow"
              class="ts-border ts-p-2 ts-w-8 ts-h-8 ts-flex ts-items-center ts-justify-center ts-rounded-md ts-mb-2 ts-absolute ts-right-0 ts-top-0 ts--mt-4 ts-mr-2 ts-bg-blue-600"
            >
              <i class="fa fa-plus ts-text-white"></i>
            </button>
            <br />
            <div
              class="ts-w-full"
              v-for="(product, index) in model.productList"
              :key="index"
            >
              <div class="ts-gap-3 ts-flex ts-w-full">
                <a-select
                  v-model="product.product_id"
                  :options="productList"
                  showSearch
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="(_, props) => onProductChange(product, props)"
                  class="ts-w-full"
                  :class="{ 'is-invalid': errors.has('product_id') }"
                ></a-select>
                <label
                  :title="product.label"
                  :for="'file_' + index"
                  class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-cursor-pointer ts-h-8"
                  :class="product.label ? 'ts-border-blue-600' : ''"
                  ><i class="fas fa-file-excel"></i
                ></label>
                <a
                  @click.prevent="removeRow(index)"
                  href="#"
                  class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-cursor-pointer ts-h-8"
                  ><i class="fa fa-trash ts-text-red-600"></i
                ></a>
                <input
                  type="file"
                  :ref="'file_' + index"
                  :id="'file_' + index"
                  class="ts-hidden"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="e => onFileChange(e, product)"
                />
              </div>
              <p
                class="ts-text-red-600 ts-mb-0"
                v-if="errors.has('productList.' + index + '.product_id')"
              >
                {{ errors.first('productList.' + index + '.product_id') }}
              </p>
              <p
                class="ts-text-red-600 ts-mb-0"
                v-if="errors.has('productList.' + index + '.serial')"
              >
                {{ errors.first('productList.' + index + '.serial') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('stockIn.remark') }}</label>
          <textarea
            v-model="model.remarks"
            rows="2"
            class="form-control ts-w-full"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('location_id')">
            {{ errors.first('location_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          {{ display_name }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
          <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
          <ts-button color="primary" @click="onImport">{{
            $t('import')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import moment from 'moment'
import * as XLSX from 'xlsx/xlsx.mjs'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'importStockInByProduct',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      display_name: null,
      file: undefined,
      model: {
        location_id: '',
        invoice_no: '',
        stock_in_date: moment().format('DD-MM-YYYY'),
        vendor_id: '',
        fix_rate: 4000,
        remarks: '',
        productList: [
          {
            product_id: '',
            uom_id: '',
            label: undefined,
            serial: []
          }
        ]
      },
      row: {
        product_id: '',
        uom_id: '',
        label: undefined,
        serial: []
      }
    }
  },
  async created() {
    this.loading = true
    await this.fetchResource().finally(() => (this.loading = false))
    this.autoSelectMainWarehouse()
    this.model.fix_rate = this.$store.state.authUser.sys_setting.fx_rate
  },
  computed: {
    ...mapState('stock/stockIn', ['locations']),
    vendorList() {
      return this.$store.state.stock.stockIn.suppliers.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    },
    productList() {
      return this.$store.state.stock.stockIn.products.map(el => ({
        value: el.product_id,
        label: el.product_name_en,
        obj: el.uom_category
      }))
    },
    locationList() {
      return this.$store.state.stock.stockIn.locations.map(el => ({
        value: el.location_id,
        label: el.location_name_en
      }))
    }
  },
  methods: {
    ...mapActions('stock/stockIn', ['fetchResource', 'importExcel']),
    addRow() {
      this.model.productList.push(Object.assign({}, this.row))
    },
    removeRow(index) {
      this.model.productList.splice(index, 1)
    },
    autoSelectMainWarehouse() {
      this.model.location_id = this.$store.state.authUser.user.warehouses
        .filter(w => w.pivot.is_default == true)
        .reduce((i, v) => (i = v.location_id), null)
    },
    onFileChange(e, product) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        product.label = fileName
        var reader = new FileReader()
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)

          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          product.serial = this.parseWorksheetData(worksheet)
        }
        reader.readAsArrayBuffer(file)
        return
      }
      this.$toasted.error('Not a valid Excel file')
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')

      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}

        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          const cell = worksheet[cellAddress]

          if (cell) {
            // const cellValue = cell ? cell.v : undefined
            row[colNum] = cell.v
          }
        }

        if (Object.keys(row).length) {
          jsonData.push(row)
        }
      }

      return jsonData
    },
    onImport() {
      this.loading = true
      this.errors = new Errors()
      this.importExcel(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.file = ''
      this.model.location_id = ''
      this.model.invoice_no = ''
      this.model.stock_in_date = moment().format('DD-MM-YYYY')
      this.model.vendor_id = ''
      this.model.remarks = ''
      this.model.productList = [
        {
          product_id: '',
          uom_id: '',
          label: undefined,
          serial: []
        }
      ]
    },
    onProductChange(product, props) {
      let defaultUom = props.data.props.obj.unit_of_measures.find(
        u => u.is_default == true
      )
      product.uom_id = defaultUom.uom_id
    }
  }
}
</script>
